import { ScholarshipTypeDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ScholarshipTypeActions from './scholarshiptype.actions';

export const SCHOLARSHIP_TYPE_FEATURE_KEY = 'scholarshiptype';

export interface ScholarshipTypeState extends EntityState<ScholarshipTypeDto> {
  selectedScholarshipTypeId?: string | number; // which ScholarshipType record has been selected
  loaded: boolean; // has the ScholarshipType list been loaded
  error?: string | null; // last none error (if any)
}

export interface ScholarshipTypePartialState {
  readonly [SCHOLARSHIP_TYPE_FEATURE_KEY]: ScholarshipTypeState;
}

export const scholarshipTypeAdapter: EntityAdapter<ScholarshipTypeDto> = createEntityAdapter<
  ScholarshipTypeDto
>({
  selectId: (scholarshipType) => scholarshipType.id,
  sortComparer: false,
});

export const initialState: ScholarshipTypeState = scholarshipTypeAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedScholarshipTypeId: null,
  }
);

const scholarshipTypeReducer = createReducer(
  initialState,
  on(ScholarshipTypeActions.loadScholarshipType, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipTypeActions.loadScholarshipTypeSuccess,
    (state, { scholarshipType }) =>
      scholarshipTypeAdapter.addAll(scholarshipType, {
        ...state,
        loaded: false,
      })
  ),
  on(ScholarshipTypeActions.loadScholarshipTypeFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ScholarshipTypeActions.addScholarshipType, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipTypeActions.addScholarshipTypeSuccess,
    (state, { newScholarshipType }) =>
      scholarshipTypeAdapter.addMany(newScholarshipType, {
        ...state,
        loaded: false,
      })
  ),
  on(ScholarshipTypeActions.addScholarshipTypeFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ScholarshipTypeActions.updateScholarshipType, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ScholarshipTypeActions.updateScholarshipTypeSuccess,
    (state, { updateScholarshipType }) =>
      scholarshipTypeAdapter.upsertMany(updateScholarshipType, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ScholarshipTypeActions.updateScholarshipTypeFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  on(ScholarshipTypeActions.removeScholarshipType, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ScholarshipTypeActions.removeScholarshipTypeSuccess, (state, { ids }) =>
    scholarshipTypeAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(
    ScholarshipTypeActions.removeScholarshipTypeFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  )
);

export function reducer(
  state: ScholarshipTypeState | undefined,
  action: Action
) {
  return scholarshipTypeReducer(state, action);
}
